/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelMoneyOutInput
 */
export interface CancelMoneyOutInput {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof CancelMoneyOutInput
     */
    accountId?: string;
}

/**
 * Check if a given object implements the CancelMoneyOutInput interface.
 */
export function instanceOfCancelMoneyOutInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CancelMoneyOutInputFromJSON(json: any): CancelMoneyOutInput {
    return CancelMoneyOutInputFromJSONTyped(json, false);
}

export function CancelMoneyOutInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelMoneyOutInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountId': !exists(json, 'accountId') ? undefined : json['accountId'],
    };
}

export function CancelMoneyOutInputToJSON(value?: CancelMoneyOutInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountId': value.accountId,
    };
}

